<div class="login-page">
  <div class="login-page-box"></div>
  <div class="login-box">
    <div class="login-logo">
      <img src="assets/img/logo.png" alt="Logo" class="login-logo">
    </div>

    <div class="card card-outline card-info">
      <div class="card-header text-center">
        <h4><b>{{nombreSistema}}</b></h4><br>
        {{descripcionSistema}}
      </div>
      <div class="card-body login-card-body">
        <p class="login-box-msg"><label>Iniciar Sesión</label></p>

        <form [formGroup]="form" (ngSubmit)="login()" novalidate>
          <div class="input-group mb-3">
            <input type="text" class="form-control" id="usuario" placeholder="Escribe tu usuario"
              formControlName="usuario" [ngClass]="{ 'is-invalid': submitted && form.controls.usuario.errors }">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-at"></span>
              </div>
            </div>
            <div *ngIf="submitted && form.controls.usuario.errors" class="invalid-feedback">
              <div *ngIf="form.controls.usuario.errors.required">El usuario es requerido</div>
            </div>
          </div>

          <div class="input-group mb-3">
            <input [type]="(isPassShow) ? 'text' : 'password'" class="form-control" id="contrasena"
              placeholder="Escribe tu contraseña" formControlName="contrasena"
              [ngClass]="{ 'is-invalid': submitted && form.controls.contrasena.errors }">
            <div class="input-group-append">
              <div class="input-group-text" (click)="showHidePassword()">
                <span [ngClass]="(isPassShow) ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
              </div>
            </div>
            <div *ngIf="submitted && form.controls.contrasena.errors" class="invalid-feedback">
              <div *ngIf="form.controls.contrasena.errors.required">La contraseña es requerida</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <button type="submit" class="btn btn-info btn-block">
                <i class="fas fa-door-open"></i>
                Ingresar
              </button>
            </div>
            <div class="col-12 fix-margin">
              <p class="mb-1 text-center">
                <a [routerLink]="" class="fidelis" (click)="showModal()">Olvidé mi contraseña</a>
              </p>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>